import React from 'react';
import { motion } from 'framer-motion';

/**
 * ScrollReveal — wraps content in an in-view animation.
 * Variants: up | left | right | fade | scale
 */
const VARIANTS = {
  up:    { initial: { opacity: 0, y: 40 },  whileInView: { opacity: 1, y: 0 } },
  left:  { initial: { opacity: 0, x: -60 }, whileInView: { opacity: 1, x: 0 } },
  right: { initial: { opacity: 0, x: 60 },  whileInView: { opacity: 1, x: 0 } },
  fade:  { initial: { opacity: 0 },         whileInView: { opacity: 1 } },
  scale: { initial: { opacity: 0, scale: 0.96 }, whileInView: { opacity: 1, scale: 1 } },
};

const ScrollReveal = ({
  children,
  variant = 'up',
  delay = 0,
  duration = 0.7,
  margin = '-80px',
  once = false,
  className = '',
  ...rest
}) => {
  const v = VARIANTS[variant] || VARIANTS.up;
  return (
    <motion.div
      initial={v.initial}
      whileInView={v.whileInView}
      viewport={{ once, margin }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
